import type { DirectoryEntry } from './hr'

function personName(p: Pick<DirectoryEntry, 'first_name' | 'last_name' | 'display_name'>): string {
  return `${p.first_name} ${p.last_name}`.trim() || p.display_name
}

export type OrgTab = 'directory' | 'orgchart'

/** Every viewer gets both tabs, the org chart first; it also carries the structure view. */
export const ORG_TABS: readonly OrgTab[] = ['orgchart', 'directory']

/** `structure` was its own tab; old links land on the org chart tab that now holds it. */
export function resolveOrgTab(param: string | null): OrgTab {
  if (param === 'structure') return 'orgchart'
  return ORG_TABS.find((tab) => tab === param) ?? ORG_TABS[0]
}

/** The plain-staff directory, filtered by one search box and sorted by name. `extra` adds the shown columns' text to what the search matches. */
export function basicDirectoryRows(
  people: DirectoryEntry[],
  query: string,
  extra?: (person: DirectoryEntry) => string[],
): DirectoryEntry[] {
  const needle = query.trim().toLowerCase()
  const rows = needle
    ? people.filter((p) =>
        [personName(p), p.position, p.team, p.email, p.phone, ...(extra?.(p) ?? [])].some((f) =>
          (f ?? '').toLowerCase().includes(needle),
        ),
      )
    : people
  return [...rows].sort((a, b) => personName(a).localeCompare(personName(b)))
}
